import { useEffect } from "react";

export default function RedirectSpmbLab() {
  useEffect(() => {
    window.location.href =
      "https://penerimaan-old.undiksha.ac.id/spmb-sekolah-lab";
  }, []);

  return null;
}
